"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactPhotoGallery = _interopRequireDefault(require("react-photo-gallery"));

var _reactIntersectionObserver = require("react-intersection-observer");

var _CircularProgress = _interopRequireDefault(require("@eig-builder/core-ui/CircularProgress"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var cont = {
  backgroundColor: '#eee',
  cursor: 'pointer',
  overflow: 'hidden',
  position: 'relative'
};

var ImageBox = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  > div {\n    display: none;\n  }\n  &:before {\n    border: 3px solid transparent;\n    background: rgba(0, 0, 0, 00);\n  }\n  &:hover {\n    &::before {\n      border: 3px solid #0082ed;\n      background: rgba(0, 0, 0, 0.5);\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      left: 0;\n      top: 0;\n      content: \"\";\n    }\n    > div {\n      display: block;\n    }\n  }\n  ", "\n"])), function (props) {
  return props.selected && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    border: 3px solid red;\n  "])));
});

var ActionsBox = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  bottom: ", ";\n  right: ", ";\n"])), function (props) {
  return props.top && '10px';
}, function (props) {
  return props.left && '10px';
}, function (props) {
  return props.bottom && '10px';
}, function (props) {
  return props.right && '10px';
});

var DefaultImage = function DefaultImage(_ref) {
  var _photo$actions5, _photo$actions6, _photo$actions7, _photo$actions8;

  var photo = _ref.photo,
      left = _ref.left,
      top = _ref.top;
  var supportsLazyLoading = ('loading' in HTMLImageElement.prototype);

  var _useInView = (0, _reactIntersectionObserver.useInView)({
    threshold: 0,
    rootMargin: '0px',
    triggerOnce: true
  }),
      _useInView2 = (0, _slicedToArray2["default"])(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  var copyPhoto = _objectSpread({}, photo);

  delete copyPhoto.backgroundColor;
  delete copyPhoto.actions;

  var getPhotoActions = function getPhotoActions(position) {
    var _photo$actions, _photo$actions2, _photo$actions3, _photo$actions4;

    switch (position) {
      case 'topLeft':
        return photo === null || photo === void 0 ? void 0 : (_photo$actions = photo.actions) === null || _photo$actions === void 0 ? void 0 : _photo$actions.topLeft;

      case 'topRight':
        return photo === null || photo === void 0 ? void 0 : (_photo$actions2 = photo.actions) === null || _photo$actions2 === void 0 ? void 0 : _photo$actions2.topRight;

      case 'bottomLeft':
        return photo === null || photo === void 0 ? void 0 : (_photo$actions3 = photo.actions) === null || _photo$actions3 === void 0 ? void 0 : _photo$actions3.bottomLeft;

      case 'bottomRight':
        return photo === null || photo === void 0 ? void 0 : (_photo$actions4 = photo.actions) === null || _photo$actions4 === void 0 ? void 0 : _photo$actions4.bottomRight;
    }
  };

  return /*#__PURE__*/_react["default"].createElement(ImageBox, {
    onClick: photo.onClick,
    ref: supportsLazyLoading === false ? ref : undefined,
    selected: photo.selected,
    style: _objectSpread(_objectSpread({}, cont), {}, {
      height: photo.height,
      width: photo.width,
      margin: 2,
      backgroundColor: photo.backgroundColor
    })
  }, inView || supportsLazyLoading ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({
    alt: photo.title
  }, copyPhoto, {
    loading: "lazy"
  })), (photo === null || photo === void 0 ? void 0 : (_photo$actions5 = photo.actions) === null || _photo$actions5 === void 0 ? void 0 : _photo$actions5.topLeft) && /*#__PURE__*/_react["default"].createElement(ActionsBox, {
    top: true,
    left: true
  }, getPhotoActions('topLeft')), (photo === null || photo === void 0 ? void 0 : (_photo$actions6 = photo.actions) === null || _photo$actions6 === void 0 ? void 0 : _photo$actions6.topRight) && /*#__PURE__*/_react["default"].createElement(ActionsBox, {
    top: true,
    right: true
  }, getPhotoActions('topRight')), (photo === null || photo === void 0 ? void 0 : (_photo$actions7 = photo.actions) === null || _photo$actions7 === void 0 ? void 0 : _photo$actions7.bottomLeft) && /*#__PURE__*/_react["default"].createElement(ActionsBox, {
    bottom: true,
    left: true
  }, getPhotoActions('bottomLeft')), (photo === null || photo === void 0 ? void 0 : (_photo$actions8 = photo.actions) === null || _photo$actions8 === void 0 ? void 0 : _photo$actions8.bottomRight) && /*#__PURE__*/_react["default"].createElement(ActionsBox, {
    bottom: true,
    right: true
  }, getPhotoActions('bottomRight'))) : null);
};

DefaultImage.propTypes = {
  photo: _propTypes["default"].object,
  left: _propTypes["default"].number,
  top: _propTypes["default"].number,
  onClick: _propTypes["default"].func
};

var GridBox = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  height: 100%;\n  overflow: auto;\n"])));

var InfinityLazyPhotoGrid = function InfinityLazyPhotoGrid(_ref2) {
  var data = _ref2.data,
      loadMore = _ref2.loadMore,
      loading = _ref2.loading,
      more = _ref2.more;

  var loader = _react["default"].useRef(loadMore);

  var observer = _react["default"].useRef(new IntersectionObserver(function (entries) {
    var first = entries[0];

    if (first.isIntersecting) {
      loader.current();
    }
  }, {
    threshold: 0
  }));

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      element = _React$useState2[0],
      setElement = _React$useState2[1];

  _react["default"].useEffect(function () {
    loader.current = loadMore;
  }, [loadMore]);

  _react["default"].useEffect(function () {
    var currentElement = element;
    var currentObserver = observer.current;

    if (currentElement) {
      currentObserver.observe(currentElement);
    }

    return function () {
      if (currentElement) {
        currentObserver.unobserve(currentElement);
      }
    };
  }, [element]);

  var imageRenderer = _react["default"].useCallback(function (props) {
    return /*#__PURE__*/_react["default"].createElement(DefaultImage, (0, _extends2["default"])({}, props, {
      onClick: function (_onClick) {
        function onClick() {
          return _onClick.apply(this, arguments);
        }

        onClick.toString = function () {
          return _onClick.toString();
        };

        return onClick;
      }(function () {
        return onClick(props.index);
      })
    }));
  }, []);

  var direction = function direction() {
    return data.length === 1 ? 'column' : 'row';
  };

  return /*#__PURE__*/_react["default"].createElement(GridBox, null, /*#__PURE__*/_react["default"].createElement(_reactPhotoGallery["default"], {
    targetRowHeight: 260,
    photos: data,
    renderImage: imageRenderer,
    direction: direction()
  }), loading && /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    centered: true
  }), !loading && more && /*#__PURE__*/_react["default"].createElement("div", {
    ref: setElement,
    style: {
      background: 'transparent',
      padding: 20
    }
  }));
};

InfinityLazyPhotoGrid.propTypes = {
  data: _propTypes["default"].array.isRequired,
  loadMore: _propTypes["default"].func,
  loading: _propTypes["default"].bool
};
var _default = InfinityLazyPhotoGrid;
exports["default"] = _default;